import { render, staticRenderFns } from "./White.vue?vue&type=template&id=55f96fd5&scoped=true&"
import script from "./White.vue?vue&type=script&lang=js&"
export * from "./White.vue?vue&type=script&lang=js&"
import style0 from "./White.vue?vue&type=style&index=0&id=55f96fd5&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f96fd5",
  null
  
)

export default component.exports